function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseFilters = function SvgIconCloseFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.908 15.072",
    height: 16,
    width: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.87 7.536 6.841-6.45a.629.629 0 0 0-.863-.914l-6.894 6.5L1.06.172a.628.628 0 1 0-.863.914l6.84 6.45-6.84 6.45a.629.629 0 0 0 .863.914l6.894-6.5 6.894 6.5a.629.629 0 0 0 .863-.913l-6.84-6.45Z",
    style: {
      fill: "#393d3c"
    },
    "data-name": "Layer 1"
  }));
};
export default SvgIconCloseFilters;